import { create } from 'zustand';

let timer: ReturnType<typeof setTimeout> | undefined;

interface ToastState {
  message: string | null;
  /** Show a transient toast (auto-hides after ~1.8s). */
  show: (message: string) => void;
  hide: () => void;
}

export const useToast = create<ToastState>((set) => ({
  message: null,
  show: (message) => {
    set({ message });
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => set({ message: null }), 1800);
  },
  hide: () => {
    if (timer) clearTimeout(timer);
    set({ message: null });
  },
}));
